<template>
  <custom-market
    :save-label="saveLabel"
  />
</template>

<script>
import { mapActions } from 'vuex';
import CustomMarket from './_CustomMarket';

export default {
  name: 'CreateCustomMarket',
  components: {
    CustomMarket,
  },
  props: {
    marketId: {
      type: String,
      default: '',
    },
  },
  computed: {
    isCreateMode() {
      return !this.marketId;
    },
    saveLabel() {
      return this.isCreateMode ? 'Create market' : 'Save changes';
    },
  },
  created() {
    this.loadCustomMarket(this.marketId);
  },
  methods: {
    ...mapActions('customMarket', ['loadCustomMarket']),
  },
};
</script>
